import * as M from "./style"
import { useSelector } from "react-redux"
import { hideModal, isModalActive } from "utils/modal"
import BaseModal from "../../base"
import WalletConnect from "components/parts/payment/walletConnect"

const WalletConnectModal = () => {

    const show = isModalActive(useSelector((state: any) => state.data.modalStates), "WalletConnectModal")

    return (
        <M.Modal>
            <BaseModal
                header={false}
                hide={() => hideModal("WalletConnectModal")}
                show={show}
            >
                <WalletConnect />
            </BaseModal>
        </M.Modal>
    )

}

export default WalletConnectModal